import * as APPCONFIG from "../config/app-config.js";
import api from "./AuthAPI.js";
import Http from "./Http.js";

export const addDoctor = (formValues) => {
  return api({
    method: "post",
    url: `${APPCONFIG.API_URL}doctor/addDoctor`,
    data: formValues,
    headers: Http.AUTH_MULTIPART_HEADERS()
  });
};

export const updateDoctor = (formValues) => {
  return api({
    method: "post",
    url: `${APPCONFIG.API_URL}doctor/updateDoctor`,
    data: formValues,
    headers: Http.AUTH_MULTIPART_HEADERS()
  });
};

export const getDoctorSpecialities = (formValues) => {
  return api({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/getDoctorSpecialities`,
    data: JSON.stringify(formValues),
    headers: Http.HEADERS()
  });
};

export const getNearByDoctors = (formValues) => {
  return api({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/getNearByDoctors`,
    data: JSON.stringify(formValues),
    headers: Http.HEADERS()
  });
};

export const getDoctorsList = (formValues) => {
  return api({
    method: "post",
    url: `${APPCONFIG.API_URL}doctor/getDoctorsList`,
    data: JSON.stringify(formValues),
    headers: Http.AUTH_HEADERS()
  });
};

export const doctorBlockOrUnblock = (formValues) => {
  return api({
    method: "post",
    url: `${APPCONFIG.API_URL}doctor/userBlockOrUnblock`,
    data: JSON.stringify(formValues),
    headers: Http.AUTH_HEADERS()
  });
};


export const getDoctorDetails = (formValues) => {
  return api({
    method: "post",
    url: `${APPCONFIG.API_URL}doctor/getDoctorDetails`,
    data: JSON.stringify(formValues),
    headers: Http.AUTH_HEADERS()
  });
};

export const getDoctorProfile = (formValues) => {
  return api({
    method: "post",
    url: `${APPCONFIG.API_URL}auth/getDoctorProfile`,
    data: JSON.stringify(formValues),
    headers: Http.HEADERS()
  });
};


export const deleteLocationById = (formValues) => {
  return api({
    method: "post",
    url: `${APPCONFIG.API_URL}doctor/deleteLocationById`,
    data: JSON.stringify(formValues),
    headers: Http.AUTH_HEADERS()
  });
};
